import { TooltipProps } from "react-leaflet";

import LeafletTooltip from "../leaflet-tooltip/LeafletTooltip";
import { Lct, NetworkElementTooltipContent } from "./NetworkElementTooltipContent";

interface AssetTooltipProps extends TooltipProps {
  asset: any;
  lctType?: Lct;
  enabled: boolean;
}

const NetworkElementTooltip = ({ asset, lctType, enabled, ...tooltipProps }: AssetTooltipProps) => {
  // Due to a bug in Leaflet, a tooltip must be present as the focus events aren't unbound if one was present
  const nullResponse = <LeafletTooltip visible={false} />;
  if (!enabled) return nullResponse;
  if (asset?.styles?.class === "node" && (asset?.linkBox === undefined || asset?.linkBox === null))
    return nullResponse;
  const content = <NetworkElementTooltipContent asset={{ ...asset }} lctType={lctType} />;
  if (!content) return nullResponse;

  return (
    <LeafletTooltip
      id={asset.id}
      tooltipProps={{
        direction: "left",
        ...tooltipProps,
      }}
    >
      {content}
    </LeafletTooltip>
  );
};

export default NetworkElementTooltip;
